/**
 * 系统公告页懒加载壳（14.24；BlacklistLazy 同构）：低频页面不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function AnnouncementsLazy() {
  const { mod } = useLazyModule(() => import('./AnnouncementsPage'));
  if (mod === null) return <div data-testid="announcements-loading-shell">加载中…</div>;
  return <mod.AnnouncementsPage />;
}
